import { createSlice } from "@reduxjs/toolkit";

const now = new Date();
const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
const d = {
    subAccountId: '',
    locationId: '',
    from: today,
    to: today,
    accountNo: ''
};

const SearchLoadSheetSlice = createSlice({
    name: 'searchLoadSheetData',
    initialState: {
        data: d,
        locations: [],
        selectedLocations: [],
        grid: []
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data;
        },
        updateData: (state, action) => {
            const key = action.payload.key;
            const val = action.payload.val;
            state.data[key] = val;
        },
        resetData: (state, action) => {
            state.data = d;
            state.selectedLocations = [];
        },
        setLocations: (state, action) => {
            state.locations = action.payload.data
        },
        setSelectedLocations: (state, action) => {
            state.selectedLocations = action.payload.data
        },
        setGrid: (state, action) => {
            state.grid = action.payload.data
        }
    }
});

export default SearchLoadSheetSlice.reducer;
export const { setData, updateData, resetData, setLocations, setGrid, setSelectedLocations } = SearchLoadSheetSlice.actions;